'use client';

import { useState } from 'react';
import Accordion from "@components/accordion";

export default function FaqAccordion({ title, text, newlines, rank }) {

    const [titleClass, setTitleClass] = useState("");

    const onMouseEnterHandler = () => {
        setTitleClass("underline");
    }

    const onMouseLeaveHandler = () => {
        setTitleClass("");
    }

    return (
        <Accordion
            title={title}
            text={text}
            newlines={newlines}
            rank={rank}
            titleClass={titleClass}
            onMouseEnter={onMouseEnterHandler} 
            onMouseLeave={onMouseLeaveHandler}
        />
    );
}